// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmedButton, toast } from '@a-type/ui';
import { graphql, useMutation } from '@biscuits/graphql';
const deleteDomainMutation = graphql(`
	mutation DeleteDomainRoute($id: ID!) {
		deleteDomainRoute(id: $id)
	}
`);
export function DeleteDomainRoute(_a) {
    var { domainRouteId, onDelete } = _a, rest = __rest(_a, ["domainRouteId", "onDelete"]);
    const [mutate] = useMutation(deleteDomainMutation, {
        variables: {
            id: domainRouteId,
        },
        onCompleted: () => {
            onDelete === null || onDelete === void 0 ? void 0 : onDelete();
            toast.success('Domain removed');
        },
    });
    return (_jsx(ConfirmedButton, Object.assign({ emphasis: "primary", confirmText: "Remember to remove your DNS entries for this domain to completely disconnect it.", confirmAction: "Remove my domain", confirmColor: "primary", color: "attention" }, rest, { onConfirm: async () => {
            await mutate();
        }, children: "Delete custom domain" })));
}
//# sourceMappingURL=DeleteDomainRoute.js.map